import { render, staticRenderFns } from "./addyimiaogroup.vue?vue&type=template&id=d4a0b480&scoped=true&"
import script from "./addyimiaogroup.vue?vue&type=script&lang=js&"
export * from "./addyimiaogroup.vue?vue&type=script&lang=js&"
import style0 from "./addyimiaogroup.vue?vue&type=style&index=0&id=d4a0b480&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a0b480",
  null
  
)

export default component.exports